import { Typography } from '@mui/material';
import { FC } from 'react';

import { TerminalWizardPage } from '../../../../general/components/wizard-page';

const PartnerAccountConflictPage: FC = () => {
  return (
    <TerminalWizardPage title={<>An application is already in progress</>}>
      <Typography variant="inherit" align="center" color="textSecondary">
        We can&apos;t process your application because your business already has one in progress.
        <br />
        Please contact your administrator or reach out to support@coastpay.com for help.
      </Typography>
    </TerminalWizardPage>
  );
};

export { PartnerAccountConflictPage };
